import React from "react";
import {stepIndexGenerateRows, stepIndexLoadKML, stepIndexPlanRoute, stepIndexSelectFeatures} from "./RainRoverConst";


function RoverPathWizard({step} ) {



    return(
        <>
            <div className={"container-fluid row"}>
                <div className={"col" + (step === stepIndexLoadKML ? " bg-primary" : "")}>Load KML</div>
                <div className={"col" + (step === stepIndexSelectFeatures ? " bg-primary" : "")}>Select Features</div>
                <div className={"col" + (step === 2 ? " bg-primary" : "")}>(Water Source)</div>
                <div className={"col" + (step === 3 ? " bg-primary" : "")}>(Reference Line)</div>
                <div className={"col" + (step === stepIndexGenerateRows ? " bg-primary" : "")}>Generate Rows</div>
                <div className={"col" + (step === 5 ? " bg-primary" : "")}>(Service Path)</div>
                <div className={"col" + (step === stepIndexPlanRoute ? " bg-primary" : "")}>Plan Route</div>
            </div>
        </>
    );


}


export default RoverPathWizard;
